import { render } from "./DanhSachVanBan.vue?vue&type=template&id=1234acc0&ts=true"
import script from "./DanhSachVanBan.vue?vue&type=script&lang=ts"
export * from "./DanhSachVanBan.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__